import { render } from "./InvoiceItemsList.vue?vue&type=template&id=65060b83"
import script from "./InvoiceItemsList.vue?vue&type=script&lang=js"
export * from "./InvoiceItemsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__